import { createStore } from 'vuex'

export default createStore({
  state: {
    language:1, //语言 1中文 2英文
    navList: [],//导航总数居
    search: '', //搜索
    selNav: {},//选中的导航对象数据
    selNavId: {
      id1: -1,
      id2: -1
    }
  },
  getters: {
  },
  mutations: {
    //语言 1中文 2英文
    setLanguage(state, language) {
      state.language = language
      localStorage.setItem('language', language)
    },
    //搜索
    setSearch(state, search) {
      state.search = search
    },
    //导航总数居
    setNavList(state, list) {
      state.navList = list
    },
    //选中的导航
    setSelNav(state, nav) {
      state.selNav = nav
      sessionStorage.setItem('selNav', JSON.stringify(nav))
    },
    //选中的导航ids
    setSelNavId(state, ids) {
      state.selNavId = ids
      sessionStorage.setItem('selNavId', JSON.stringify(ids))
    },
  },
  actions: {
  },
  modules: {
  }
})
